export default "__VITE_ASSET__DxH8zZ_A__"